import { Dashboard, Dns, Group, ImportContacts, Message, Security, Settings } from '@mui/icons-material';

import { IMenuItem } from '../types';
import { ROUTES } from './routes';

export const MENU_LIST: IMenuItem[] = [
  {
    route: ROUTES.dashboard,
    literal: 'menuDashboard',
    Icon: Dashboard
  },
  {
    route: ROUTES.edit,
    literal: 'menuMemos',
    Icon: Dns
  }
];

export const SYSTEM_MENU_LIST: IMenuItem[] = [
  {
    route: ROUTES.messages,
    literal: 'menuMessages',
    Icon: Message
  },
  // {
  //   route: ROUTES.authentication_test,
  //   literal: 'menuAuthenticationTest',
  //   Icon: Security
  // }
];

export const LIB_MENU_LIST: IMenuItem[] = [
  {
    route: ROUTES.training,
    literal: 'menuTraining',
    Icon: ImportContacts
  }
];

export const SETTINGS_MENU_LIST: IMenuItem[] = [
  {
    route: ROUTES.settings,
    literal: 'menuSettings',
    Icon: Settings
  }
];
